import React, { useEffect, useState } from 'react'
import ReactECharts from 'echarts-for-react';
import Swal from 'sweetalert2';
import { getPropertyPayments } from './Analytics_API';
import { CircularProgress } from '@mui/material';

const AnalyticsWrapper = () => {
    const [noDataFound, setNoDataFound] = useState<boolean>(false)
    const [analyticsData, setAnalyticsData] = useState<any>({
        month: [],
        paidAmount: [],
        expectedAmount: []
    })
    const [loading, setLoading] = useState<boolean>(true)
    // function to get Property Payments Analytics
    async function getPropertyPaymentsAnalytics() {
        setLoading(true)
        try {
            const { data: res } = await getPropertyPayments()
            if (res.code === '200') {
                if (res.data.length > 0) {
                    setNoDataFound(false)
                    const month: any = []
                    const paidAmount: any = []
                    const expectedAmount: any = []
                    res.data.forEach((data: any) => {
                        month.push(data.month)
                        paidAmount.push(Number(data.paid))
                        expectedAmount.push(Number(data.totalExpected) - Number(data.paid))
                    })
                    setAnalyticsData({
                        month,
                        paidAmount,
                        expectedAmount
                    })
                } else {
                    setNoDataFound(true)
                }
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                    text: res.msg_details,
                    allowOutsideClick: true,
                })
            }
        } catch (error: any) {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error,
            })
        }
        finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        getPropertyPaymentsAnalytics()
    }, [])
    const rawData = [
        analyticsData.paidAmount,//collected rent
        analyticsData.expectedAmount, //expected rent
    ];
    const totalData: number[] = [];
    for (let i = 0; i < rawData[0].length; ++i) {
        let sum = 0;
        for (let j = 0; j < rawData.length; ++j) {
            sum += rawData[j][i];
        }
        totalData.push(sum);
    }

    const grid = {
        left: 30,
        right: 10,
        top: 50,
        bottom: 50
    };

    const series: echarts.BarSeriesOption[] = [
        'Collected Rent',
        'Expected Rent',
    ].map((name, sid) => {
        return {
            name,
            type: 'bar',
            stack: 'total',
            barWidth: '60%',
            label: {
                show: true,
                formatter: (params: any) => Math.round(params.value * 1000) / 10 + '%'
            },
            data: rawData[sid].map((d: any, did: any) =>
                totalData[did] <= 0 ? 0 : d / totalData[did]
            )
        };
    });

    const option = {
        color: ['#ac4481', '#d4ae6a'],
        legend: {
            selectedMode: false
        },
        grid,
        yAxis: {
            type: 'value'
        },
        xAxis: {
            type: 'category',
            data: analyticsData.month
        },
        series
    };
    return (
        <>
            {
                loading ?
                    // {* Begin: loader*}
                    <div
                        className='d-flex justify-content-center align-items-center vh-70'
                        style={{ height: '70vh' }}
                    >
                        <CircularProgress />
                    </div>
                    :
                    <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                        <div className='d-flex flex-column flex-column-fluid'>
                            {/* Begin: header for property page */}
                            <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between mb-5 px-5 flex-wrap'>
                                {/* Begin: Heading */}
                                <h1
                                    className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center'
                                >
                                    Analytics
                                </h1>
                            </div>
                            <div id='table div'>
                                {noDataFound ? (
                                    <div className='card card-body'>
                                        <span className='d-flex flex-column align-items-center flex-start p-10'>
                                            <img
                                                src='/media/svg/undraw/property.svg'
                                                alt='No document uploaded'
                                                className='h-200px w-200px'
                                            />
                                            <span className='fw-bold text-muted fs-1 text-center'>
                                                No Data Found For Analytics
                                            </span>
                                        </span>
                                    </div>
                                ) : (
                                    <div className='card mb-5 mb-xl-8'>
                                        <div className='card-body py-3'>
                                            <div><ReactECharts option={option} style={{ height: 400 }} /></div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
            }
        </>
    )
}

export default AnalyticsWrapper